import { Injectable, inject } from '@angular/core'
import { Filter, RestClientPaged } from '@elderbyte/ngx-starter'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../environments/environment'
import { OptimisationDay } from './optimisation-day'

export class OptimisationDayFilter {
  public static facilityId(facilityId: string): Filter {
    return new Filter('facilities', facilityId)
  }
}

@Injectable({
  providedIn: 'root',
})
export class OptimisationDayService extends RestClientPaged<OptimisationDay, string> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/optimisation', http, {
      idField: 'id',
    })
  }
}
